import type { ContentBlock, SavedContentBlock } from "../ContentBlock.js";
import type { ContentBlockData } from "../ContentBlockData.js";
import { ContentType } from "../ContentType.js";
import type { Media } from "../Media.js";
import { contentBlockSchemaMap } from "../contentBlockSchemaMap.js";

const imageGetters: { [K in ContentType]: ((data: ContentBlockData<K>) => Media | undefined) | undefined } = {
	[ContentType.Benefits]: undefined,
	[ContentType.CKEditor]: undefined,
	[ContentType.ContactButton]: undefined,
	[ContentType.Gallery]: ({ images }) => images[0],
	[ContentType.ImageBanner]: ({ image }) => image,
	[ContentType.Lock]: undefined,
	[ContentType.Link]: undefined,
	[ContentType.UnorderedList]: undefined,
	[ContentType.Quotation]: ({ image }) => image,
};

export function findImageInContentBlocks(blocks: (ContentBlock | SavedContentBlock)[]): Media | undefined {
	return blocks
		.map<Media | undefined>((block) => {
			const data = contentBlockSchemaMap[block.type].parse(
				typeof block.data === "string" ? JSON.parse(block.data) : block.data,
			);
			return imageGetters[block.type]?.(
				/* @ts-expect-error data is dynamically typed */
				data,
			);
		})
		.find(Boolean);
}
